var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_618_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 5.33325C21.3 5.33325 11.1666 13.9199 11.1666 27.1999C11.1666 35.6799 17.7 45.6533 30.74 57.1466C31.7533 58.0266 33.2733 58.0266 34.2866 57.1466C47.3 45.6533 53.8333 35.6799 53.8333 27.1999C53.8333 13.9199 43.7 5.33325 32.5 5.33325ZM32.5 31.9999C29.5666 31.9999 27.1666 29.5999 27.1666 26.6666C27.1666 23.7333 29.5666 21.3333 32.5 21.3333C35.4333 21.3333 37.8333 23.7333 37.8333 26.6666C37.8333 29.5999 35.4333 31.9999 32.5 31.9999Z",
    fill: "#611180"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_618_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.d54dbf8142d0a13e765950a87fe35716.svg";
export { ForwardRef as ReactComponent };